import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-generic-notes-v2',
    templateUrl: './generic-notes-v2.component.html',
    styleUrls: ['./generic-notes-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericNotesV2Component implements OnInit, AfterViewInit {
@Input() configData;
  @Input() frmGroup;
  notes : any[] = [];
  counter;
  recordNumber=1;
  disabled = false;
  showError:boolean = false;
  errorMsg = '';
  @ViewChild('textareanote',{static: true, read: ElementRef}) textNote: ElementRef;
  constructor( private appService: AppService) { }

  ngOnInit() {
    //this.frmGroup.get(this.configData.name).value = [{"userId":"jkhjkhbjkbjk","note":"nkjkjjk","createdDate":"klkl ","recordNumber":"9809809"}]
    this.disabled = this.configData.disabled
    this.counter = this.configData.maxChars
    if (this.configData['dynamicVisibility']) {
      if(this.configData['dynamicVisibility'].action == 'hidden'){
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      }else if(this.configData['dynamicVisibility'].action == 'disabled'){
        if(this.checkAccess(this.configData['dynamicVisibility'].featureName) == false){
          this.disabled = true;
        }
      }
    }
     //CP-2967
     if(!this.frmGroup.get(this.configData.name).value && this.configData.defaultValue){
      this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue);
    }

    if (this.frmGroup.get(this.configData.name).value) {
      this.notes = this.frmGroup.get(this.configData.name).value;
    }
  }
  ngAfterViewInit(){
    if(this.frmGroup.get(this.configData.name).value)
      this.notes = this.frmGroup.get(this.configData.name).value;
    //CP-2967
    // else(!this.frmGroup.get(this.configData.name).value && this.configData.defaultValue)
    //   this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue);
  }

  inputTextarea(){
    this.counter =  this.configData.maxChars - this.textNote.nativeElement.value.length;
  }
  addNote(e){
    var pattern = /^[^*|\":<>[\]`\\';#/]+$/;
    if(pattern.test(this.textNote.nativeElement.value.trim())){
      this.showError = false;
      let currentcreatedDate = new Date();
      let note = {}
      if(this.configData.params.includes('userId') )
        note['userId'] = localStorage.firstName + ' ' + localStorage.lastName;
      if(this.configData.params.includes('createdDate') )
        note['createdDate'] = this.appService.formatcreatedDateUTC(currentcreatedDate);
      if(this.configData.params.includes('noteText') )
        note['noteText'] = this.textNote.nativeElement.value;
      if(this.notes.length>0 && this.configData.params.includes('recordNumber'))
        {
          this.recordNumber = this.notes[0].recordNumber +1;
          for (let n in this.notes){
            if(this.recordNumber<=n['recordNumber']){
              this.recordNumber = n['recordNumber']+1
              
            }
          } 
          
        }
       
      note['recordNumber'] = this.recordNumber;
      this.notes.push(note)
      this.textNote.nativeElement.value="";
  
      this.frmGroup.get(this.configData.name).value = this.notes
      this.frmGroup.markAsTouched();
    }else{
      this.showError = true;
      this.errorMsg = 'Special character not allowed.';
    }
  }

   formatcreatedDate(t) {
    let n = new Date();
    var d = new Date(t),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
      let hour = n.getHours();
      let min = n.getMinutes();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [day, month, year].join('/') + ', ' + [hour, min].join(':');
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

}
